module.exports = __webpack_public_path__ + "static/cale1-7a1d24b0ed08860e43884ca803cfcc35.jpg";